
export interface MyDocumentsItem {
	id: string;
	createdAt: string;
	name: string;
	contentURL: string;	
	document_type_name?: string;
}

export interface MyDocumentsState {
	documents: MyDocumentsItem[];
	contentLoaded: boolean;	
}


export enum MyDocumentsActions {
	SET_MY_DOCUMENTS_LIST = 'SET_MY_DOCUMENTS_LIST',
}